import greiffPremiumSf from './GreiffPremiumSf.jpeg';

export const greiffPremiumSfImpressions = {
    greiffPremiumSf,
};
